var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ctrl-api-histories-google-api-histories"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("Google API送信履歴")])])],1),_c('GoogleApiHistories',{attrs:{"pageType":'ctrl'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }